import { Injectable, Renderer2, RendererFactory2 } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LazyLoadImgService {
  private renderer: Renderer2;
  private observer: IntersectionObserver | null = null;
  private imageElements = new Set<HTMLImageElement>();
  scrollTimeout:any

  constructor(rendererFactory: RendererFactory2) {
    this.renderer = rendererFactory.createRenderer(null, null);
    this.initializeObserver();
    
  }

  private initializeObserver() {
    if (this.observer) {
      this.observer.disconnect();
    }
    this.observer = new IntersectionObserver((entries: IntersectionObserverEntry[]) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const img = entry.target as HTMLImageElement;
          this.setImageSrc(img);
          this.observer?.unobserve(img);
          this.imageElements.delete(img);
        }
      });
    }, {
      root: null,
      rootMargin: '0px',
      threshold: 0.5
    });
    this.imageElements.forEach(image => this.observer?.observe(image));
  }

  registerImage(image: HTMLImageElement) {
    if (!this.imageElements.has(image)) {
      this.imageElements.add(image);
      if (this.observer) {
        this.observer.observe(image);
      }
    }
  }

  unregisterImage(image: HTMLImageElement) {
    if (this.imageElements.has(image)) {
      this.imageElements.delete(image);
      this.observer?.unobserve(image);
    }
  }

  private setImageSrc(image: HTMLImageElement) {
    const src = image.getAttribute('data-src');
    if (src) {
      this.renderer.setAttribute(image, 'src', src);
    }
  }

  isScrollingStopped(){
    let self = this;
    self.observer.disconnect()
    clearTimeout(this.scrollTimeout);
    self.scrollTimeout = setTimeout(() => {
      self.initializeObserver();  // Initialize observer only after scroll stops
    }, 150);
  }

}
